import {DomainStore} from 'shared/store';
import {action, observable} from 'mobx';
import {endpoints, types} from 'main/tools';

class ManageContainerState {
  store = new DomainStore();
  history;

  @observable agent;

  receiveProps({history}) {
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.agent = agent;
  }

  @action async createPolicy() {
    const {model} = await this.store.post(
      endpoints.EXPENSES.POLICIES.ALL,
      types.EXPENSES.POLICY
    );

    this.history.push(`/manage/policies/${model.id}/edit`);
  }

  @action async removePolicy(policy) {
    await this.store.destroy(policy);
    await this.agent.refresh();
  }

}

export default ManageContainerState;
